import { createSlice } from "@reduxjs/toolkit";
import { DEFAULT_LANGUAGE } from '../../constant/appConstant';

const initialState = {
  isAuthentication: false,
  token: '',
  refresh_token: '',
  authLoading: false,
  userId: null,
  firstName: null,
  fullName: null,
  lastName: null,
  emailAddress: null,
  phoneNumber: null,
  imageUrl: null,
  language: DEFAULT_LANGUAGE,
  skeletonLoading: false,
  postLoading: false,
  mapping_user: [],
  active_user: null,
  is_completion_account: true,
  is_waiting_approve: false,
  grolog_account_id: null,
  username: '',
  role: '',

  prepareComponent: false,
  error_auth: '',
  title: null,
  client_id: '',
  resource_user_id: '13',

  permission:{},
  menu:[],
  grologAccInfo:{},
}

export const authenticationSlice = createSlice({
  name: 'isAuthentication',
  initialState: initialState,
  reducers: {
    setAuthentication: (state, action) => {
      state.isAuthentication = action.payload
    },
    setAuthLoading: (state, action) => {
      state.authLoading = action.payload
    },
    setToken: (state, action) => {
      state.token = action.payload
    },
    setClientId: (state, action) => {
      state.client_id = action.payload
    },
    setRefreshToken: (state, action) => {
      state.refresh_token = action.payload
    },
    setMappingUser: (state, action) => {
      state.mapping_user = action.payload
    },
    setActiveUser: (state, action) => {
      state.active_user = action.payload
    },
    setUserId: (state, action) => {
      state.userId = action.payload
    },
    setFirstName: (state, action) => {
      state.firstName = action.payload
    },
    setFullName: (state, action) => {
      state.fullName = action.payload
    },
    setLastName: (state, action) => {
      state.lastName = action.payload
    },
    setUsername: (state, action) => {
      state.username = action.payload
    },
    setRole: (state, action) => {
      state.role = action.payload
    },
    setEmailAddress: (state, action) => {
      state.emailAddress = action.payload
    },
    setPhoneNumber: (state, action) => {
      state.phoneNumber = action.payload
    },
    setImageUrl: (state, action) => {
      state.imageUrl = action.payload
    },
    setLanguage: (state, action) => {
      state.language = action.payload
    },
    setSkeletonLoading: (state, action) => {
      state.skeletonLoading = action.payload
    },
    setPostLoading: (state, action) => {
      state.postLoading = action.payload
    },
    setPrepareComponent: (state, action) => {
      state.prepareComponent = action.payload
    },
    setTitle: (state, action) => {
      state.title = action.payload
    },
    setGrologAccId: (state, action) => {
      state.grolog_account_id = action.payload
    },
    setErrorAuth: (state, action) => {
      state.error_auth = action.payload
    },
    clearAuthentication: (state) => {
      state.isAuthentication = false
    },
    setIsCompletionAcc: (state, action) => {
      state.is_completion_account = action.payload
    },
    setIsWaitingApprove: (state, action) => {
      state.is_waiting_approve = action.payload
    },
    clearSession: (state = initialState) => {
      return initialState
    },
    setPermission:(state,action)=>{
      state.permission=action.payload
    },
    setMenu:(state,action)=>{
      state.menu=action.payload
    },
    setGrologAccInfo:(state,action)=>{
      state.grologAccInfo = action.payload
    },
  }
});

export const {
  setAuthentication,
  setAuthLoading,
  setEmailAddress,
  setFirstName,
  setActiveUser,
  setMappingUser,
  setRefreshToken,
  setFullName,
  setImageUrl,
  setLanguage,
  setLastName,
  setPhoneNumber,
  setPostLoading,
  setPrepareComponent,
  setSkeletonLoading,
  setTitle,
  setToken,
  setUserId,
  setErrorAuth,
  clearSession,
  clearAuthentication,
  setClientId,
  setIsCompletionAcc,
  setIsWaitingApprove,
  setGrologAccId,
  setUsername,
  setRole,
  setPermission,
  setMenu,
  setGrologAccInfo,
} = authenticationSlice.actions;

export default authenticationSlice.reducer